<template>
  <div class="common_bg">
    <!-- 筛选 -->
    <el-form :inline="true">
      <!-- 房间名称 -->
      <el-form-item class="input213">
        <el-input
          v-model="params.meterName"
          :placeholder="$t('lang.请输入设备名称')"
          @keyup.enter.native="onClickSearch"
        >
          <i slot="prefix" class="el-icon-search"></i>
        </el-input>
      </el-form-item>
      <!-- 操作时间 -->
      <el-form-item :label="$t('lang.操作时间')" class="input285">
        <el-date-picker
          v-model="timeValue"
          type="daterange"
          align="right"
          unlink-panels
          :range-separator="$t('lang.至')"
          :picker-options="pickerOptions"
          :clearable="false"
          value-format="yyyy-MM-dd HH:mm:ss"
        >
        </el-date-picker>
      </el-form-item>
      <!-- 层级名称 -->
      <el-form-item :label="$t('lang.层级名称')" class="input138">
        <el-select v-model="params.rootId">
          <el-option
            v-for="item of levelList"
            :key="item.rootId"
            :label="item.rootName"
            :value="item.rootId"
          ></el-option>
        </el-select>
      </el-form-item>
      <!-- 查询 -->
      <el-form-item>
        <el-button type="primary" size="medium" @click="onClickSearch">{{
          $t("lang.查询")
        }}</el-button>
      </el-form-item>
      <!-- 导出 -->
      <el-form-item>
        <el-button type="primary" plain size="medium" @click="onClickExport">{{
          $t("lang.导出")
        }}</el-button>
      </el-form-item>
    </el-form>
    <!-- 表格 -->
    <el-table
      :data="tableData"
      style="width: 100%"
      max-height="400"
      v-loading="loading"
    >
      <el-table-column
        v-for="item in tableTitle"
        :key="item.prop"
        :prop="item.prop"
        align="center"
        :label="$t('lang.' + item.label)"
        :formatter="formatter"
        :min-width="item.width"
      >
      </el-table-column>
    </el-table>
    <div class="payment_bottom">
      <el-pagination
        class="bottom_page"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        :current-page="params.pageNum"
        @current-change="pageChange"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="10"
        :total="totalCount"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { mapActions } from "vuex";
import { UsageTableTitle } from "./define";
import { pickerOptions } from "../collection-details/define";
import levelMixin from "@/app/common/mixin/mixin-levelList.js";
export default {
  name: "UsageDetails",
  mixins: [levelMixin],
  data() {
    return {
      params: {
        meterName: "",
        startTime: "",
        endTime: "",
        rootId: "",
        pageNum: 1,
        pageSize: 10,
      },
      //#region 表格
      tableData: [],
      tableTitle: UsageTableTitle,
      totalCount: 0,
      loading: false,
      //#endregion

      //#region 时间选择器控件
      timeValue: [],
      pickerOptions: pickerOptions,
      //#endregion
    };
  },
  created() {
    this.timeValue = [
      moment().subtract(7, "days").format("YYYY-MM-DD 00:00:00"),
      moment().format("YYYY-MM-DD 23:59:59"),
    ];
    this.iUseKwhRangeTime();
  },
  methods: {
    ...mapActions({
      useKwhRangeTime: "ZD_UseKwhRangeTime",
    }),
    async iUseKwhRangeTime() {
      this.loading = true;
      try {
        let res = await this.useKwhRangeTime(this.getParams());
        if (res.success !== 1 || this.isnull(res.listitem)) throw new Error("");
        res.listitem.forEach((elem, idx) => {
          elem.idx = (this.params.pageNum - 1) * this.params.pageSize + idx + 1;
        });
        this.tableData = res.listitem;
        this.totalCount = res.totalItemCount;
      } catch (e) {
        this.tableData = [];
        this.totalCount = 0;
      } finally {
        this.loading = false;
      }
    },
    getParams() {
      this.params.startTime = "";
      this.params.endTime = "";
      if (this.timeValue.length > 1) {
        this.params.startTime = this.timeValue[0];
        this.params.endTime = moment(this.timeValue[1]).format("YYYY-MM-DD 23:59:59");
      }
      return this.params;
    },
    onClickSearch() {
      this.params.pageNum = 1;
      this.iUseKwhRangeTime();
    },
    //#region 表格
    formatter(row, { property }) {
      if (this.isnull(row[property])) return "--";
      if (property == "useKwh") {
        return this.fix(row[property], { empty: "--" });
      }
      return row[property];
    },
    handleSizeChange(size) {
      this.params.pageNum = 1;
      this.params.pageSize = size;
      this.iUseKwhRangeTime();
    },
    pageChange(e) {
      this.params.pageNum = e;
      this.iUseKwhRangeTime();
    },
    //#endregion

    onClickExport() {
      if (this.isnull(this.tableData))
        return this.$message.warning(this.$t("lang.当前无导出数据"));
      const tempTitle = this.docopy(this.tableTitle);
      tempTitle.shift();
      tempTitle.forEach((elem) => {
        elem.label = this.$t("lang." + elem.label);
      });
      this.$download(this.params, tempTitle, "EXPORT_UseKwhRangeTime");
    },
  },
};
</script>

<style lang="less" scoped>
.common_bg {
  /deep/ .el-form-item {
    margin-right: 20px;
  }
  .el-icon-search {
    padding-left: 5px;
  }
  .input213 /deep/ .el-input {
    width: 230px;
  }

  .input138 /deep/ .el-input {
    width: 138px;
  }
  .input285 /deep/ .el-date-editor--daterange.el-input__inner {
    width: 285px;
  }
}
.payment_bottom {
  width: 100%;
  height: 60px;
  .bottom_page {
    position: absolute;
    bottom: 20px;
    right: 20px;
  }
}
</style>